import { render, staticRenderFns } from "./SimplifiedTherapiesList.vue?vue&type=template&id=14b22d58&scoped=true&"
import script from "./SimplifiedTherapiesList.vue?vue&type=script&lang=js&"
export * from "./SimplifiedTherapiesList.vue?vue&type=script&lang=js&"
import style0 from "./SimplifiedTherapiesList.vue?vue&type=style&index=0&id=14b22d58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b22d58",
  null
  
)

export default component.exports